import React, {useEffect} from 'react'
import {Box, Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {useTranslation} from "react-i18next";


const RelevanceLayout = ()=>{
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/relevance",
            type:"pageView"
        }))
    });
    return(
        <React.Fragment>
            <Box
                component="main"
            >
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('relevance_page.title') as any}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('relevance_page.paragraph_1') as any}
                </Typography>
                <Typography paragraph>
                    {t('relevance_page.paragraph_2') as any}
                </Typography>
                <Typography paragraph>
                    {t('relevance_page.paragraph_3') as any}
                </Typography>
                <Typography paragraph>
                    {t('relevance_page.paragraph_4') as any}
                </Typography>
                <Typography paragraph>
                    {t('relevance_page.paragraph_5') as any}
                </Typography>
            </Box>
        </React.Fragment>
    )
}
export default RelevanceLayout
